export default "__VITE_ASSET__27KF21wy__"